module.exports = __webpack_public_path__ + "static/media/arrow_down.22dfd496.svg";